export enum Direction {
  FORWARD = 'FORWARD',
  BACKWARDS = 'BACKWARDS',
}

interface ErrorMessages {
  [key: string]: string;
}

export const ErrorMessages: ErrorMessages = {
  // App
  UNKNOWN_ERROR: 'Wystąpił nieznany błąd',
  INTERNAL_SERVER_ERROR: 'Wystąpił błąd komunikacji z serwerem',
  'name should not be empty': 'Pole nazwy nie może być puste',

  // Account
  ACCOUNT_BLOCKED: 'Twoje konto zostało zablokowane',
  LOGIN_BAD_CREDENTIALS: 'Podałeś błędne dane logowania',
  USER_WRONG_PASSWORD: 'Podałeś złe hasło',
  ADMIN_NO_ACCESS: 'Nie masz dostępu administratora',
  REFRESH_TOKEN_EXPIRED: 'Token wygasł',
  REFRESH_TOKEN_NOT_FOUND: 'Token nie został znaleziony',
  USER_NOT_FOUND: 'Użytkownik nie został znaleziony',
  'Forbidden resource': 'Brak dostępu',

  // Address
  ADDRESS_NOT_FOUND: 'Adres nie został znaleziony',

  // Business
  BUSINESS_NOT_FOUND: 'Biznes nie został znaleziony',
  NOT_VALID_REGON: 'Błędny numer REGON',
  NOT_VALID_NIP: 'Błędny numer nip',
  NOT_VALID_BDO: 'Błędny numer bdo',
  BUSINESS_REGON_EXISTS: 'Podmiot z danym numerem REGON już istnieje',
  BUSINESS_NIP_EXISTS: 'Podmiot z danym numerem nip już istnieje',
  BUSINESS_BDO_EXISTS: 'Podmiot z danym numerem bdo już istnieje',
  BUSINESS_EXISTS: 'Podmiot firmowy o takiej nazwie już istnieje',
  'phoneNumber must be a valid phone number': 'Błędny numer telefonu',
  'bankAccount.bankName must be a string': 'Rachunek bankowy zawiera błędy',

  // Sales point
  SALES_POINT_EXISTS: 'Punkt sprzedaży o takiej nazwie już istnieje',
  'fileId must be a UUID': 'Plik logo jest wymagany',

  // Workplace group
  WORKPLACE_GROUP_EXISTS: 'Grupa stanowisk o takiej nazwie już istnieje',
  'template must be a valid numbering template string':
    'Niepoprawna struktura numeracji faktur',

  // Workplace
  WORKPLACE_EXISTS: 'Stanowisko o takiej nazwie już istnieje',
  WORKPLACE_CODE_EXISTS: 'Kod stanowiska istnieje',
  WORKPLACE_INACTIVE: 'Stanowisko nieaktywne',

  // Cash register
  CASH_REGISTER_NOT_FOUND: 'Kasa nie została znaleziona',
  CASH_REGISTER_HISTORY_NOT_FOUND: 'Historia kasy nie została znaleziona',
  CASH_REGISTER_TEMPLATE_REMOVE_ACTIVE: `Nie można usunąć aktywnej kasy`,
  OPEN_CASH_REGISTER_NOT_FOUND: 'Nie ma otwartej kasy dla tego stanowiska',
  CASH_REGISTER_CLOSED: 'Kasa jest zamknięta',
  CASH_REGISTER_ALREADY_OPENED: 'Kasa jest już otwarta dla tego stanowiska',
  CASH_REGISTER_PRINTING_NOT_SUPPORTED:
    'Durkowanie kasy nie jest wspierane dla tej operacji',
  INSUFFICIENT_FUNDS: 'Brak środków w kasie do wykonania operacji',
  PAYMENT_TYPE_ALREADY_SET: 'Nie można zmienić typu płatności na obecny typ',

  // Client
  CLIENT_NOT_FOUND: 'Klient nie został znaleziony',
  NIP_ALREADY_EXISTS: 'Klient z podanym NIP istnieje',
  'phone must be a valid phone number': 'Pole "numer telefonu" zawiera błędy',

  // Desktop
  DESKTOP_NOT_FOUND: 'Pulpit nie został znaleziony',
  DESKTOP_LINE_NOT_FOUND: 'Linia pulpitu nie została znaleziona',
  DESKTOP_EXISTS: 'Pulpit o takiej nazwie już istnieje',

  // Device
  PRINTER_NOT_FOUND: 'Drukarka nie została znaleziona',
  PRINTER_OFFLINE: 'Drukarka jest offline',
  NO_PERIPHERAL_FOUND: 'Nie znaleziono urządzeń peryferyjnych',
  TURNSTILE_NOT_FOUND: 'Kołowrotek nie został znaleziony',
  TURNSTILE_HISTORY_RECORD_NOT_FOUND:
    'Historia kołowrotka nie została znaleziona',
  COUPON_PRINTER_NOT_FOUND: 'Drukarka bonowa nie została znaleziona',
  USB_DEVICE_NOT_FOUND: 'Urządzene usb nie zostało znalezione',
  SERIAL_PORT_DEVICE_NOT_FOUND:
    'Urządzenie z portu szeregowego nie zostało znalezione',
  'tcpHost must be an ip address': 'Błędny numer ip',
  'couponPrinter.symlinkName must be letter or digits only':
    'Pole symlinkName w drukarce bonowej musi składać się wyłącznie z liter lub cyfr',
  'receiptPrinter.symlinkName must be letter or digits only':
    'Pole symlinkName w drukarce fiskalnej musi składać się wyłącznie z liter lub cyfr',
  'None config provided': 'Nie podano danych konfiguracyjnych',
  'Printer not ready; Printer communication port: 2':
    'Port drukarki zablokowany, należy zresetować drukarkę',
  NO_CHROME: 'Brak google-chrome pod ścieżką: /usr/bin/google-chrome',

  // Discount
  DISCOUNT_NOT_FOUND: 'Zniżka nie została znaleziona',
  DISCOUNT_NOT_IN_VALID_PERIOD:
    'Okres rabatowy nie wlicza się do żadnego ważnego okresu',
  DISCOUNT_VALUE_GREATER_THAN_PRICE:
    'Wartość rabatu jest większa niż cena produktu',
  DISCOUNT_EXIST: 'Rabat o takiej nazwie już istnieje',
  PAPER_RUNNING_OUT: 'Błąd drukarki. Papier na wyczerpaniu',
  PRINTER_NOT_READY_COMMUNICATION_PORT:
    'Port drukarki zablokowany, należy zresetować drukarkę',

  // Invoice
  INVOICE_NOT_FOUND: 'Faktura nie została znaleziona',
  INVOICE_TYPE_MISMATCH: `Typ faktury nie jest zgodny z typem klienta`,
  INVOICE_ALREADY_ISSUED: `Nie można modyfikować wystawionych faktur`,
  INVOICE_CODE_TEMPLATE_NOT_FOUND: 'Nie znaleziono szablonu kodu faktury',
  ACTIVE_INVOICE_CODE_TEMPLATE_NOT_FOUND:
    'Nie znaleziono aktywnego szablonu kodu faktury',
  INVOICE_TEMPLATE_PERIOD_OVERLAP:
    'Szablon kodu faktury za ten okres już istnieje',
  INVOICE_TEMPLATE_REMOVE_ACTIVE: `Nie można usunąć aktywnego szablonu faktury`,
  INVOICE_ALREADY_EXISTS: 'Faktura na ten paragon już istnieje',
  WORKPLACE_INVOICE_CODE_ALREADY_ISSUED: `Nie można zaktualizować kodu stanowiska, ponieważ w bieżącym okresie wystawiono fakturę`,
  WORKPLACE_INVOICE_CODE_NOT_SET:
    'Nie ustawiono kodu stanowiska na fakturze. Zaktualizuj stanowisko.',
  INVOICE_HIGHER_LINE_QUANTITY: `Wybrana ilość linii jest większa niż zakupiona`,
  INVOICE_NOT_ISSUED: 'Faktura nie została wystawiona',
  INVOICE_NIP_MISMATCH: `Nip klienta nie jest zgodny z nipem na paragonie`,
  CORRECTION_INVOICE_ISSUED: 'Faktura korygująca została już wystawiona',
  BUYER_SELLER_NIP_MATCH: 'NIP musi być różny dla sprzedawcy i kupującego',
  INVOICE_PRICE: `Kwota faktury nie może wynosić 0zł!`,

  // Location
  LOCATION_NOT_FOUND: 'Lokalizacja nie została znaleziona',
  LOCATION_EXISTS: 'Lokalizacja o podanej nazwie istnieje',
  LOCATION_INVOICE_CODE_MISSING:
    'Szablon kodu faktury nie jest ustawiony dla bieżącej lokalizacji',
  LOCATION_CODE_EXISTS: 'Kod lokalizacji istnieje',

  // Order
  ORDER_NOT_FOUND: 'Zamówienie nie zostało znalezione',
  ORDER_LINE_NOT_FOUND: 'Linia zamówienia nie została znaleziona',
  RECEIPT_NOT_FOUND: 'Rachunek nie został znaleziony',
  NON_VALUE_ORDER_NOT_ALLOWED: 'Sprzedaż za 0zł jest zablokowana',
  'Actions cannot be performed on the order that is already finalized':
    'Nie można usunąć produktu z istniejącego zamówienia. Proszę zresetować zamówienie.',
  NO_RECEIPT_CONFIRMATION: 'Brak potwierdzenia transakcji dla tego zamówienia',
  ORDER_ALREADY_REFUNDED: 'Towar lub zamówienie zostało już zwrócone',
  TIME_PERIOD_FOR_PAYMENT_METHOD_CHANGE_EXPIRED:
    'Okres czasowy zmiany metody płatności minął dla tego zamówienia',
  WRONG_PAYMENT_TYPE: 'Niepoprawna metoda zwrotu',
  INVALID_DISCOUNT_CODE: 'Niepoprawny kod rabatowy',
  'Actions cannot be performed on the order that is not in created state':
    'Nie można wykonać operacji na zamówieniu, którego płatność została już rozpoczęta',

  // Permission
  GROUP_NOT_FOUND: 'Grupa nie została znaleziona',
  ROLE_NOT_FOUND: 'Rola nie została znaleziona',
  GROUP_HAS_USERS: 'Nie można usunąć grupy zawierającej użytkowników',
  GROUP_NAME_EXISTS: 'Grupa o podanej nazwie już istnieje',

  // Price-list
  VALID_PERIOD_NOT_FOUND: 'Okres nie został znaleziony',
  PRICE_LIST_NOT_FOUND: 'Cennik nie został znaleziony',
  PRICING_EXIST: 'Nazwa cennika istnieje',

  // Product
  PRODUCT_CATEGORY_NOT_FOUND: 'Kategoria nie została znaleziona',
  PRODUCT_NOT_FOUND: 'Produkt nie został znaleziony',
  PRODUCT_VARIANT_NOT_FOUND: 'Wiariant produktu nie został znaleziony',
  PRODUCT_BLOCKED: 'Produkt jest zablokowany',
  PRODUCT_EXISTS: 'Produkt o podanej nazwie już istnieje',
  PRODUCT_CATEGORY_EXISTS: 'Kategoria o podanej nazwie już istnieje',
  PRODUCT_VARIANT_EXISTS: 'Wariant produktu o podanej nazwie już istnieje',
  PRODUCT_OUTSIDE_LOCATION: 'Podany produkt nie istnieje w podanej lokalizacji',
  PRODUCT_LOCKED: 'Sprzedaż produktu zablokowana; sprawdź stawkę VAT',
  PAYMENT_FAILED: 'Transakcja odrzucona',

  // Synchronization
  SYNCHRONIZATION_FAILED: 'Synchronizacja nie powiodła się',
  SYNCHRONIZATION_VERSION_FAILED:
    'Wymagana aktualizacja aplikacji w celu synchronizacji',
  SYNCHRONIZATION_STATUS_NOT_FOUND:
    'Status synchronizacji nie został znaleziony',

  // Tax-rate
  TAX_RATE_NOT_FOUND: 'Stawka podatkowa nie została znaleziona',

  // Template
  NUMBERING_TEMPLATE_USED: `Nie można zaktualizować/usunąć szablonu z wydanymi numerami`,

  // Ticket
  TICKET_NOT_FOUND: 'Bilet nie został znaleziony',
  TICKET_NOT_VALID: 'Bilet nie jest już ważny',
  TOP_UP_VALUE_NOT_VALID: 'Niepoprawna wartość doładowania',
  TICKET_HISTORY_NOT_FOUND: 'Historia biletu nie została znaleziona',
  TICKET_ALREADY_EXISTS: 'Bilet o podanym kodzie już istnieje',
  CANNOT_TOP_UP_NON_POINT_TICKET: 'Nie można doładować biletu niepunktowego',
  TICKET_NOT_IN_ASSIGNED_VALID_PERIOD: 'Bilet poza okresem obowiązywania',
  TURNSTILE_FREEZE_TIME: 'Blokada czasowa',
  INVALID_CSV: 'Plik CSV zawiera błędne wartości w wierszach: ',

  // Wireless card
  CARD_NOT_FOUND: 'Karta zbliżeniowa nie została znaleziona',
  CARD_ALREADY_EXISTS: 'Karta o takim numerze istnieje w systemie',
  CARD_HAS_ACTIVE_TIME_TICKET:
    'Na karcie jest już aktywny bilet czasowy. Użyj innej karty.',

  // Valid-period
  VALID_PERIOD_OVERLAP:
    'Okres obowiązywania cennika pokrywa się z już istniejącym dla wybranych lokalizacji',

  // Workplace
  WORKPLACE_NOT_FOUND: 'Stanowisko nie zostało znalezione',
  WORKPLACE_NO_ACCESS: 'Nie masz dostępu do tego stanowiska',

  // Background
  BACKGROUND_NOT_FOUND: 'Tło nie zostało znalezione',

  // Unique filter
  ENTITY_DUPLICATE_FOUND:
    'W naszej bazie istnieje już wpis z taką wartością - ',

  // ticket history
  NO_ENTRIES_LEFT: 'Brak punktów',
  TICKET_VALID_PERIOD_END: 'Koniec ważności biletu',
  TICKET_VALID_AFTER_SCAN_PERIOD_END: 'Koniec ważności biletu',
  TIME_TICKET_SCAN_VALID_PERIOD_END: 'Koniec ważności biletu',
  TURNSTILE_ONGOING_TECHNICAL_BREAK: 'Trwa przerwa techniczna',
  NON_MATCHING_WORKPLACE: 'Błędne stanowisko',
  NON_MATCHING_WORKPLACE_GROUPS: 'Błędna grupa kołowrotów',
  TICKET_BLOCKED: 'Bilet zablokowany',
  NON_MATCHING_LOCATION: 'Błędna lokalizacja',

  // deposit
  CANNOT_RETURN_CARD: 'Nie można zwrócić karty',
  CARD_ALREADY_USED: 'Karta została już użyta',

  // agreement
  AGREEMENT_EXISTS: 'Umowa o takiej nazwie już istnieje',
  AGREEMENT_INSUFFICIENT_FUNDS: 'Niewystarczające środki umowy',
  CANNOT_UPDATE_USED_AGREEMENT: 'Nie można zaktualizować używanej umowy',

  'variants.0.quantity must not be greater than 10000':
    'Przekroczono maksymalną liczbę produktów',

  //smtp
  AUTHENTICATION_FAILED: 'Błędne hasło lub host',
  WRONG_VERSION_NUMBER: 'Błąd SMTPS lub niewłaściwy port',
  NOT_OWNED: 'Błędny adres wysyłkowy',

  // technical break
  TECHNICAL_BREAK_ALREADY_ENDED: 'Przerwa techniczna została już zakończona',
  TECHNICAL_BREAK_ALREADY_STARTED: 'Przerwa techniczna została już rozpoczęta',
  UNPLANED_TECHNICAL_BREAK_STARTED:
    'Przerwa techniczna została już rozpoczęta dla kołowrotów: ',

  // E-commerce
  SALES_GROUP_MAX_SOLD_TICKETS_EXCEEDED:
    'Brak wystarczającej liczby wolnych miejsc w wybranym terminie',
  SALES_GROUP_TIME_SLOT_UNAVAILABLE: 'Wybrany przedział czasowy jest niedostępny',
  SALES_GROUP_TIME_THRESHOLD_UNAVAILABLE:
    'Wybrana długość rezerwacji jest niedostępna',
  SALES_GROUP_TIME_BASED_RATE_UNAVAILABLE:
    'Wybrana długość rezerwacji jest niedostępna',
  SALES_GROUP_TIME_BASED_BOOKING_INVALID: 'Nieprawidłowy termin rezerwacji',
  SALES_GROUP_VEHICLE_PLATE_ALREADY_BOOKED:
    'Pojazd o podanym numerze rejestracyjnym ma już rezerwację w tym terminie',
  SALES_GROUP_VEHICLE_PLATES_COUNT_MISMATCH:
    'Liczba numerów rejestracyjnych nie zgadza się z liczbą miejsc',
  SELF_STORAGE_NO_FREE_CARDS: 'Brak wolnych skrytek w tej lokalizacji',

  // Customer
  CUSTOMER_ACCOUNT_NOT_ACTIVATED:
    'Konto nie jest aktywowane. Proszę sprawdzić swoją pocztę elektronową w celu aktywacji konta',
  PASSWORD_RESET_TOKEN_EXPIRED: 'Token resetowania hasła wygasł',
  CUSTOMER_NOT_FOUND: 'Klient nie został znaleziony',
  CHANGE_PASSWORD_BAD_CREDENTIALS: 'Aktualne hasło jest nieprawidłowe',
  EMAIL_ALREADY_USED: 'Ten adres e-mail jest już używany',

  //
  WORKPLACE_GROUP_POS_SERVER_ERROR: 'Nie uruchomiono aplikacji Neopos',

  CUSTOMER_EXISTS: 'Użytkownik z takimi danymi logowania istnieje',
};
